import axios from "axios";
import Vue from "vue";
import { DateTime } from "luxon";

const state = {
  /**
   * Vybrané vozidlo
   */
  vehicle: null,
  /**
   * Období počátek.
   * Období je většinou jeden den.
   */
  periodFrom: null,
  /**
   * Období konec.
   * Období je většinou jeden den.
   */
  periodTo: null,
  /**
   * Události k zobrazení
   */
  paramCodes: ["panic", "cargo_door"],
  /**
   * Jízdy pro vybarné obodbí
   */
  events: null,
  /**
   * Aktuálně vybraná událost
   */
  event: null,
  fetching: false,
  fetched: null,
  running: null
};

const getters = {};

const actions = {
  clear({ commit, state }) {
    if (state.fetching)
      return Promise.resolve();

    if (state.vehicel !== null || state.periodFrom !== null || state.periodTo !== null || state.events !== null || state.event !== null) {
      commit("fetched", {
        vehicle: null,
        periodFrom: null,
        periodTo: null,
        paramCodes: state.paramCodes,
        events: null,
        event: null
      });
    }
  },

  refresh({ state, dispatch }) {
    if (state.query !== null) {
      dispatch("fetch", state.query);
    }
  },

  /**
   * Stáhne události vodzila podle zadaných parametrů.
   * Parametry: {
   *   vehicle: string,     - objekt vozidla
   *   periodFrom: string,  - datum a čas od
   *   periodTo: string,    - datum a čas do
   *   paramCodes: string[] - parametry ke stažení
   *   timestamp: string        - vybrat událost (datum a čas)
   *  }
   *
   * @param params Parametry
   */
  fetch({ commit, state, dispatch }, params) {
    // pokud se vozidla právě vyčítaji, nic nedělěj
    if (state.fetching)
      return Promise.resolve();

    // nastavime, ze se objekt s touto URL uz stahuje, aby se to neptalo nekolikrat
    commit("fetching");

    try {
      if (params.vehicle === null || params.vehicle === undefined) {
        if (state.vehicle !== null)
          // pokud není vozidlo zadáno použij stávající (ale pouze pokud je zadáno)
          params.vehicle = state.vehicle;
        else {
          commit("fetched", {});
          return Promise.resolve();
        }
      }

      var change = (state.vehicle === null || state.vehicle === undefined || state.vehicle.vehicleId !== params.vehicle.vehicleId || params.refresh);
      var paramCodes;
      var events = null;
      var event = null;
      let tid;

      if (params.paramCodes !== undefined && params.paramCodes !== null) {
        paramCodes = params.paramCodes;
        change = true;
      } else
        paramCodes = state.paramCodes;

      return dispatch("progress/add", "Fetch record", { root: true })
        .then(id => {
          tid = id;
          // načti jízdy pouze pokud se změnilo období
          if (change || state.periodFrom == null || state.periodFrom !== params.periodFrom
            || state.periodTo == null || state.periodTo !== params.periodTo) {
            change = true;

            // nacti měření
            return axios.get(`/v1/{#company#}/vehicle/${params.vehicle.vehicleId}/measures?from=${encodeURIComponent(params.periodFrom)}&to=${encodeURIComponent(params.periodTo)}&params=${paramCodes.join(",")}&withLocations=true&withPersons=true&size=2000`)
              .then((response) => {
                events = response.data.content;
                return Promise.resolve();
              }).catch((error) => {
                commit("fetched", {});
                console.log("Vehicle measures (events) fetch error", error);
                return undefined;
              });
          } else {
            events = state.events;
            return Promise.resolve();
          }
        })
        .then(() => {
          if (params.timestamp !== undefined && (state.event === null || state.event.timestamp !== params.timestamp || state.event.parameterId !== params.parameterId))
            event = events.find(x => x.timestamp === params.timestamp && x.parameterId === params.parameterId) || null;

          commit("fetched", {
            query: params,
            vehicle: params.vehicle,
            periodFrom: params.periodFrom,
            periodTo: params.periodTo,
            paramCodes: paramCodes,
            events: events,
            event: event
          });

          // zruš předchozí mód
          this.dispatch("online/mapMode", "events");

          return Promise.resolve();
        })
        .catch(() => {
          console.log("Fetch error");
        })
        .finally(() => {
          commit("finished");
          dispatch("progress/remove", tid, { root: true });
        });
    } catch {
      commit("finished");
      return Promise.resolve();
    }
  }
};

const mutations = {
  fetched(state, params) {
    Vue.set(state, "query", params.query || null);
    Vue.set(state, "vehicle", params.vehicle || null);
    Vue.set(state, "periodFrom", params.periodFrom || null);
    Vue.set(state, "periodTo", params.periodTo || null);
    Vue.set(state, "paramCodes", params.paramCodes || []);
    Vue.set(state, "events", params.events || null);
    Vue.set(state, "event", params.event || null);
  },

  eventChanged(state, params) {
    Vue.set(state, "event", params.event);
  },

  /**
   * Nastaví začátek stahování
   */
  fetching(state) {
    Vue.set(state, "fetching", true);
  },

  finished(state) {
    Vue.set(state, "fetching", false);
    Vue.set(state, "fetched", DateTime.now());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};